import http from './axios';

// 获取用户信息
export const getUserInfo = () => {
    return http.get22('/thirdParty/advertisement/user/getUserInfo')
};
